import { Link } from "react-router";
import { parent_routes } from "../../router/all_routes";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Avvvatars from "avvvatars-react";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { useSelector } from "react-redux";
import { useChildrenDetails } from "../../../core/common/context/ChildrenDetailsContext";
import { useEffect, useState } from "react";
import { useAcademicYear } from "../../../core/common/context/AcademicYearContext";

export const ExtendHeaderPageComponent = (props: any) => {
  return (
    <div className="dash-select-student d-none d-md-flex align-items-center mb-2">
      <h6 className="mb-0">Enfants</h6>
      <div className="student-active d-flex align-items-center ms-2 flex-wrap">
        {props?.childrenDetails?.map((student: any, idx: number) => {
          return (
            <Link
              key={idx}
              to="#"
              onClick={() => {
                props.setSelectedChild(student?.id);
              }}
              title={`${student.firstname || ""} ${student.lastname || ""}`}
              aria-label={`${student.firstname || ""} ${student.lastname || ""}`}
              className={`avatar avatar-lg p-1 me-2 ${
                props.activeStudent === student?.id && "active"
              }`}
            >
              <Avvvatars
                value={`${student.firstname?.charAt(0) || ""}${student.lastname?.charAt(0) || ""}`}
                style="character"
              />
            </Link>
          );
        })}
      </div>
    </div>
  );
};

const ParentDashboard = () => {
  const routes = parent_routes;

  const { selectedYear } = useAcademicYear();

  const userData = useSelector((state: any) => state.auth.user);
  const { childrenDetails, selectedChild, setSelectedChild } =
    useChildrenDetails();
  const [selectedChildInfos, setSelectedChildInfos] = useState<any>();

  useEffect(() => {
    const matchedChild = childrenDetails.find(
      (c: any) => c.id === selectedChild,
    );
    // console.log("Matched !: ",matchedChild)
    if (matchedChild) setSelectedChildInfos(matchedChild);
  }, [selectedChild, childrenDetails]);

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Tableau de bord</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.parentDashboard}>Accueil</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Tableau de bord
                  </li>
                </ol>
              </nav>
            </div>
            <ExtendHeaderPageComponent
              childrenDetails={childrenDetails}
              activeStudent={selectedChild}
              setSelectedChild={setSelectedChild}
              handleClick={(selectedChild: any) =>
                setSelectedChild(selectedChild)
              }
            />
          </div>

          {/* /Page Header */}

          <div className="row">
            <div className="col-xxl-12">
              {/* Profile */}
              <div className="d-flex">
                <div className="card bg-dark position-relative flex-fill">
                  <div className="card-body">
                    <div className="d-flex align-items-center row-gap-3">
                      <div className="avatar avatar-xxl rounded flex-shrink-0 me-3">
                        <Avvvatars
                          value={`${userData.firstname?.charAt(0) || ""}${userData.lastname?.charAt(0) || ""}`}
                          style="character" // ou "character"
                          size={70}
                        />
                      </div>
                      <div className="d-block">
                        {/*<span className="badge bg-transparent-primary text-primary mb-1">
                          #P124556
                        </span>*/}
                        <h4 className="text-truncate text-white mb-1">
                          {`${userData.firstname || ""} ${userData.lastname || ""}`}
                        </h4>
                        <span>
                          Ajoute le :
                          {new Date(userData.createdAt).toLocaleString(
                            "fr-FR",
                            {
                              // weekday: "short",
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                              // hour: "2-digit",
                              // minute: "2-digit",
                              // hour12: false,
                            },
                          )}
                        </span>

                        <div className="d-flex align-items-center flex-wrap row-gap-2 class-info">
                          <span>
                            Enfant :{" "}
                            {`${selectedChildInfos?.firstname || ""} ${selectedChildInfos?.lastname || ""}`}
                          </span>
                          {selectedChildInfos?.academicYear?.id !==
                          selectedYear?.id ? (
                            <span>Aucune inscription pour cette Annee</span>
                          ) : (
                            <>
                              <span>
                                Classe :{" "}
                                {`${selectedChildInfos?.class?.Level?.abbreviation || ""} - ${selectedChildInfos?.class?.label || ""}`}
                              </span>
                              <span>
                                Annee :{" "}
                                {`${selectedChildInfos?.academicYear?.label || ""}`}
                              </span>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="student-card-bg">
                      <ImageWithBasePath
                        src="assets/img/bg/circle-shape.png"
                        alt="Bg"
                      />
                      <ImageWithBasePath
                        src="assets/img/bg/shape-02.png"
                        alt="Bg"
                      />
                      <ImageWithBasePath
                        src="assets/img/bg/shape-04.png"
                        alt="Bg"
                      />
                      <ImageWithBasePath
                        src="assets/img/bg/blue-polygon.png"
                        alt="Bg"
                      />
                    </div>
                  </div>
                </div>
              </div>
              {/* /Profile */}
            </div>

            <div className="col-xxl-6">
              <div className="card">
                <div className="card-header d-flex align-items-center justify-content-between">
                  <h4 className="card-title">Liens Rapides</h4>
                </div>
                <div className="card-body pb-1">
                  <div className="row">
                    <div className="col-6 col-md-4 mb-1">
                      <Link
                        to={routes.studentEDT}
                        className="d-block bg-success-transparent ronded p-2 text-center mb-3 class-hover"
                      >
                        <div className="avatar avatar-lg border p-1 border-success rounded-circle mb-2">
                          <span className="d-inline-flex align-items-center justify-content-center w-100 h-100 bg-success rounded-circle">
                            <i className="ti ti-calendar" />
                          </span>
                        </div>
                        <p className="text-dark">Emploi du Temps</p>
                      </Link>
                    </div>
                    <div className="col-6 col-md-4 mb-1">
                      <Link
                        to={routes.studentCourse}
                        className="d-block bg-secondary-transparent ronded p-2 text-center mb-3 class-hover"
                      >
                        <div className="avatar avatar-lg border p-1 border-secondary rounded-circle mb-2">
                          <span className="d-inline-flex align-items-center justify-content-center w-100 h-100 bg-secondary rounded-circle">
                            <i className="ti ti-license" />
                          </span>
                        </div>
                        <p className="text-dark">Cours</p>
                      </Link>
                    </div>
                    <div className="col-6 col-md-4 mb-1">
                      <Link
                        to={routes.studentNote}
                        className="d-block bg-primary-transparent ronded p-2 text-center mb-3 class-hover"
                      >
                        <div className="avatar avatar-lg border p-1 border-primary rounded-circle mb-2">
                          <span className="d-inline-flex align-items-center justify-content-center w-100 h-100 bg-primary rounded-circle">
                            <i className="ti ti-hexagonal-prism" />
                          </span>
                        </div>
                        <p className="text-dark">Notes</p>
                      </Link>
                    </div>
                    <div className="col-6 col-md-4 mb-1">
                      <Link
                        to={routes.studentAttendance}
                        className="d-block bg-warning-transparent ronded p-2 text-center mb-3 class-hover"
                      >
                        <div className="avatar avatar-lg border p-1 border-warning rounded-circle mb-2">
                          <span className="d-inline-flex align-items-center justify-content-center w-100 h-100 bg-warning rounded-circle">
                            <i className="ti ti-calendar-share" />
                          </span>
                        </div>
                        <p className="text-dark">Absences</p>
                      </Link>
                    </div>
                    <div className="col-6 col-md-4 mb-1">
                      <Link
                        to={routes.paymentList}
                        className="d-block bg-success-transparent ronded p-2 text-center mb-3 class-hover"
                      >
                        <div className="avatar avatar-lg border p-1 border-success rounded-circle mb-2">
                          <span className="d-inline-flex align-items-center justify-content-center w-100 h-100 bg-success rounded-circle">
                            <i className="ti ti-cash" />
                          </span>
                        </div>
                        <p className="text-dark">Paiements</p>
                      </Link>
                    </div>
                    <div className="col-6 col-md-4 mb-1">
                      <Link
                        to={routes.requestList}
                        className="d-block bg-warning-transparent ronded p-2 text-center mb-3 class-hover"
                      >
                        <div className="avatar avatar-lg border p-1 border-warning rounded-circle mb-2">
                          <span className="d-inline-flex align-items-center justify-content-center w-100 h-100 bg-warning rounded-circle">
                            <i className="ti ti-file-text" />
                          </span>
                        </div>
                        <p className="text-dark">Demandes</p>
                      </Link>
                    </div>
                    <div className="col-6 col-md-4 mb-1">
                      <Link
                        to={routes.childExams}
                        className="d-block bg-primary-transparent ronded p-2 text-center mb-3 class-hover"
                      >
                        <div className="avatar avatar-lg border p-1 border-primary rounded-circle mb-2">
                          <span className="d-inline-flex align-items-center justify-content-center w-100 h-100 bg-primary rounded-circle">
                            <i className="ti ti-hexagonal-prism" />
                          </span>
                        </div>
                        <p className="text-dark">Examens</p>
                      </Link>
                    </div>
                    <div className="col-6 col-md-4 mb-1">
                      <Link
                        to={routes.claims}
                        className="d-block bg-danger-transparent ronded p-2 text-center mb-3 class-hover"
                      >
                        <div className="avatar avatar-lg border p-1 border-danger rounded-circle mb-2">
                          <span className="d-inline-flex align-items-center justify-content-center w-100 h-100 bg-danger rounded-circle">
                            <i className="ti ti-alert-circle" />
                          </span>
                        </div>
                        <p className="text-dark">Réclamations</p>
                      </Link>
                    </div>
                    <div className="col-6 col-md-4 mb-3">
                      <Link
                        to={routes.messagePage}
                        className="d-block bg-info-transparent ronded p-2 text-center mb-3 class-hover"
                      >
                        <div className="avatar avatar-lg border p-1 border-info rounded-circle mb-2">
                          <span className="d-inline-flex align-items-center justify-content-center w-100 h-100 bg-info rounded-circle">
                            <i className="ti ti-mail" />
                          </span>
                        </div>
                        <p className="text-dark">Mes messages</p>
                      </Link>
                    </div>
                  </div>
                </div>
                {/* </Slider> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ParentDashboard;
